export default __webpack_public_path__ + "static/sust-third-8850ec75df1810168a62bbbcfea34f15.png";